import React from "react";
import { Input } from "./Field";

/** Two-field date-range filter shared by the report screens. */
const DateRangeForm = ({ startDate, endDate, onStart, onEnd, onSubmit }) => (
  <form onSubmit={onSubmit} className="mb-3 grid grid-cols-2 gap-2">
    <Input floatAlways type="date" label="Από ημ/νία" value={startDate} onChange={(e) => onStart(e.target.value)} required />
    <Input floatAlways type="date" label="Έως ημ/νία" value={endDate} onChange={(e) => onEnd(e.target.value)} required />
  </form>
);

export default DateRangeForm;
